@if ((prepareForScreenshot$ | async)===false) {
  <div #panel class="settings-container" [class.right]="positionRight">
    <div class="settings-open-buttons" [class]="{'right': positionRight, 'transparent': !isOpen}"
      (click)="onAnyPanelTap()">
      <div class="settings-menu" [class.selected]="isOpen">
        <div (click)="toggleSettings()" class="settings-button">
          <div class="svg-icon">
            <od-svg-icon class="svg-wrapper" [name]="isOpen ? ICONS.SETTINGS.iconSelected : ICONS.SETTINGS.icon"></od-svg-icon>
          </div>
          <span class="svg-label">{{ ICONS.SETTINGS.name }}</span>
        </div>
        @if (isOpen) {
          <div class="submenu" [class]="positionRight ? 'right' : 'left'">
            <div (click)="setBrandingSettings()" class="option">
              <div class="option-svg">
                <od-svg-icon class="svg-wrapper" [name]="THEME_ICONS[this.themeName].icon"></od-svg-icon>
              </div>
              <span class="option-label">Switch Theme</span>
            </div>
            @if (speechRecognitionEnabled && voiceRecognitionService.isVoiceRecognitionAllowed && showSpeech()) {
              @if (isVoiceActive$ | async) {
                <div class="option"
                  (click)="deactivateMicrophone()">
                  <div class="option-svg">
                    <od-svg-icon class="svg-wrapper" [name]="MICROPHONE_ICONS.muted"></od-svg-icon>
                  </div>
                  <span class="option-label">Deactivate</span>
                </div>
              } @else {
                <div
                  class="option" (click)="activateMicrophone()">
                  <div class="option-svg">
                    <od-svg-icon class="svg-wrapper" [name]="MICROPHONE_ICONS.unmuted"></od-svg-icon>
                  </div>
                  <span class="option-label">Activate</span>
                </div>
              }
            }
            @if (canAccessAdmin) {
              <a [href]="orAdminUrl" class="toolbar-button-content"
                (click)="openAdmin($event)" class="option">
                <div class="option-svg">
                  <od-svg-icon class="svg-wrapper" [name]="ICONS.ADMIN.icon"></od-svg-icon>
                </div>
                <span class="option-label">{{ ICONS.ADMIN.name }}</span>
              </a>
            }
            <div (click)="logout()" class="option">
              <div class="option-svg">
                <od-svg-icon class="svg-wrapper" [name]="ICONS.LOGOUT.icon"></od-svg-icon>
              </div>
              <span class="option-label">{{ username }}</span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
